import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { GoogleReviews } from '../../components/feature/GoogleReviews';
import { useState } from 'react';

export default function ServiciosLuzPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: '¿Cuánto puedo ahorrar en mi factura de luz?',
      answer: 'El ahorro depende de tu consumo y tarifa actual. La mayoría de nuestros clientes ahorran entre 15€ y 35€ al mes. Revisamos tu factura gratis y te damos una cifra exacta.'
    },
    {
      question: '¿Tengo que cambiar de compañía obligatoriamente?',
      answer: 'No. Si tu tarifa actual ya es competitiva, te lo diremos con total honestidad. Solo recomendamos cambios cuando hay un ahorro real y significativo.'
    },
    {
      question: '¿Hay permanencia o costes ocultos?',
      answer: 'No. Las tarifas que recomendamos no tienen permanencia y puedes cambiar cuando quieras sin penalizaciones. Nuestro servicio de asesoría es completamente gratuito.'
    },
    {
      question: '¿Cuánto tarda el proceso de cambio?',
      answer: 'El cambio de compañía tarda entre 15 y 30 días. Durante ese tiempo no te quedas sin luz y nosotros gestionamos todo el papeleo por ti.'
    },
    {
      question: '¿Qué necesito para que reviséis mi factura?',
      answer: 'Solo necesitamos una foto o PDF de tu última factura de luz. Con eso podemos analizar tu consumo, potencia contratada y tarifa actual para encontrar la mejor opción.'
    },
    {
      question: '¿Trabajáis con todas las compañías?',
      answer: 'Sí. Comparamos tarifas de todas las comercializadoras del mercado (Endesa, Iberdrola, Naturgy, Repsol, TotalEnergies, y muchas más) para encontrar la mejor para ti.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section - Titular Principal */}
      <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/e199413ddf4008be3c296d983bba3ba5.jpg bright home interior with natural sunlight streaming through large windows illuminating living room warm golden light rays energy efficient LED lighting contemporary residential space comfortable cozy atmosphere sustainable home design clean minimalist aesthetic&width=1920&height=1080&seq=servluz001&orientation=landscape)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/75 via-gray-900/60 to-gray-900/75 z-0"></div>

        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <span className="inline-block text-sm font-semibold text-[#FF8F00] bg-orange-500/20 backdrop-blur-sm px-6 py-2 rounded-full mb-6 border border-orange-500/30">
            ⚡ Servicios de Luz
          </span>

          <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 leading-tight">
            Ahorra en tu factura de luz<br />
            sin cambiar tus hábitos
          </h1>
          
          <p className="text-2xl md:text-3xl text-white/90 font-light mb-12 max-w-4xl mx-auto">
            Analizamos tu contrato actual y te ofrecemos la mejor opción según tu consumo real.
          </p>

          {/* Bullets de impacto */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12 max-w-3xl mx-auto">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-4 rounded-full border border-white/20">
              <div className="w-8 h-8 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold">Revisión gratuita de tu factura</span>
            </div>

            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-4 rounded-full border border-white/20">
              <div className="w-8 h-8 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold">Sin permanencia</span>
            </div>

            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-4 rounded-full border border-white/20">
              <div className="w-8 h-8 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold">Gestión completa por un asesor</span>
            </div>
          </div>

          {/* CTA Principal */}
          <Link 
            to="/subir-factura"
            className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-10 py-6 rounded-full text-xl transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            🔥 Enviar mi factura ahora
          </Link>

          <p className="text-white/80 text-sm mt-6">
            Respuesta en menos de 24 horas • Sin compromiso
          </p>
        </div>
      </section>

      {/* Cómo funciona */}
      <section className="py-24 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block text-sm font-semibold text-[#0A5FFF] bg-blue-50 px-4 py-2 rounded-full mb-4">
              Proceso simple
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1F2937] mb-4">
              Cómo funciona nuestro servicio
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              En 3 pasos sencillos empiezas a pagar menos en tu factura de luz
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-[#F7F9FC] rounded-3xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-20 h-20 bg-[#0A5FFF] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white font-bold text-3xl">1</span>
              </div>
              <h3 className="text-2xl font-bold text-[#1F2937] mb-4">Envías tu factura</h3>
              <p className="text-gray-600 leading-relaxed">
                Sube una foto o PDF de tu última factura de luz. Es rápido, seguro y no necesitas registrarte.
              </p>
            </div>

            <div className="bg-[#F7F9FC] rounded-3xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-20 h-20 bg-[#00C853] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white font-bold text-3xl">2</span>
              </div>
              <h3 className="text-2xl font-bold text-[#1F2937] mb-4">Analizamos tu consumo</h3>
              <p className="text-gray-600 leading-relaxed">
                Nuestro equipo revisa tu factura y compara con todas las tarifas del mercado para encontrar la mejor opción.
              </p>
            </div>

            <div className="bg-[#F7F9FC] rounded-3xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-20 h-20 bg-[#FF8F00] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white font-bold text-3xl">3</span>
              </div>
              <h3 className="text-2xl font-bold text-[#1F2937] mb-4">Recibes tu propuesta</h3>
              <p className="text-gray-600 leading-relaxed">
                Te enviamos un análisis personalizado con el ahorro exacto y gestionamos el cambio si decides aceptar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Segmentación de usuarios */}
      <section className="py-24 px-4 bg-gradient-to-br from-blue-50 to-teal-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1F2937] mb-4">
              Soluciones para cada tipo de hogar
            </h2>
            <p className="text-xl text-gray-600">
              Encuentra la tarifa perfecta según tu perfil de consumo
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Perfil 1: Consumo bajo */}
            <div className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-home-smile-line text-3xl text-[#0A5FFF]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1F2937] mb-3">Consumo bajo</h3>
              <p className="text-gray-600 mb-4">
                Ideal para pisos pequeños, parejas o personas que pasan poco tiempo en casa.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-check-line text-[#00C853]"></i>
                  Menos de 150 kWh/mes
                </li>
                <li className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-check-line text-[#00C853]"></i>
                  Potencia 2.3 - 3.45 kW
                </li>
                <li className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-check-line text-[#00C853]"></i>
                  Ahorro medio: 12-18€/mes
                </li>
              </ul>
              <Link
                to="/subir-factura"
                className="block text-center bg-[#0A5FFF] hover:bg-blue-700 text-white font-semibold py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                Revisar mi factura
              </Link>
            </div>

            {/* Perfil 2: Consumo medio */}
            <div className="bg-gradient-to-br from-[#FF8F00] to-orange-600 rounded-3xl p-8 shadow-xl transform scale-105">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-home-heart-line text-3xl text-white"></i>
              </div>
              <div className="inline-block bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full mb-3">
                <span className="text-xs font-bold text-white">MÁS POPULAR</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">Consumo medio</h3>
              <p className="text-white/90 mb-4">
                Perfecto para familias de 3-4 personas con electrodomésticos habituales.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center gap-2 text-sm text-white">
                  <i className="ri-check-line text-white"></i>
                  150 - 300 kWh/mes
                </li>
                <li className="flex items-center gap-2 text-sm text-white">
                  <i className="ri-check-line text-white"></i>
                  Potencia 3.45 - 5.75 kW
                </li>
                <li className="flex items-center gap-2 text-sm text-white">
                  <i className="ri-check-line text-white"></i>
                  Ahorro medio: 20-30€/mes
                </li>
              </ul>
              <Link
                to="/subir-factura"
                className="block text-center bg-white hover:bg-gray-100 text-[#FF8F00] font-bold py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                Quiero ahorrar ahora
              </Link>
            </div>

            {/* Perfil 3: Consumo alto */}
            <div className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-home-gear-line text-3xl text-[#00C853]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1F2937] mb-3">Consumo alto</h3>
              <p className="text-gray-600 mb-4">
                Para familias numerosas, casas grandes o con climatización intensiva.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-check-line text-[#00C853]"></i>
                  Más de 300 kWh/mes
                </li>
                <li className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-check-line text-[#00C853]"></i>
                  Potencia &gt; 5.75 kW
                </li>
                <li className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-check-line text-[#00C853]"></i>
                  Ahorro medio: 30-50€/mes
                </li>
              </ul>
              <Link
                to="/subir-factura"
                className="block text-center bg-[#00C853] hover:bg-green-700 text-white font-semibold py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                Revisar mi factura
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Beneficios claros */}
      <section className="py-24 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1F2937] mb-4">
              Por qué elegirnos para tu luz
            </h2>
            <p className="text-xl text-gray-600">
              Más de 500 familias ya están ahorrando con nosotros
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-[#F7F9FC] rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-[#0A5FFF] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-euro-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-[#1F2937] mb-2">Ahorro garantizado</h3>
              <p className="text-sm text-gray-600">
                Solo recomendamos cambios si hay ahorro real. Si no, te lo decimos.
              </p>
            </div>

            <div className="bg-[#F7F9FC] rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-[#00C853] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-[#1F2937] mb-2">Sin permanencia</h3>
              <p className="text-sm text-gray-600">
                Cambia cuando quieras sin penalizaciones ni ataduras.
              </p>
            </div>

            <div className="bg-[#F7F9FC] rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-[#FF8F00] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-[#1F2937] mb-2">Asesor personal</h3>
              <p className="text-sm text-gray-600">
                Un experto te acompaña durante todo el proceso.
              </p>
            </div>

            <div className="bg-[#F7F9FC] rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-list-3-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-[#1F2937] mb-2">Gestión completa</h3>
              <p className="text-sm text-gray-600">
                Nos encargamos de todo el papeleo y trámites.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Google Reviews */}
      <GoogleReviews maxReviews={6} />

      {/* FAQ */}
      <section className="py-24 px-4 bg-[#F7F9FC]">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1F2937] mb-4">
              Preguntas frecuentes
            </h2>
            <p className="text-xl text-gray-600">
              Resolvemos tus dudas sobre el servicio de luz
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <span className="font-bold text-[#1F2937] pr-4">{faq.question}</span>
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-[#0A5FFF] transition-transform ${
                      openFaq === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 text-center bg-white rounded-2xl p-8 shadow-sm">
            <p className="text-gray-700 mb-4">
              ¿Tienes más preguntas? Estamos aquí para ayudarte
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/34696237625?text=Hola,%20tengo%20una%20pregunta%20sobre%20el%20servicio%20de%20luz"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>

              <a
                href="tel:696237625"
                className="inline-flex items-center justify-center gap-2 bg-[#0A5FFF] hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Llamar ahora
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-24 px-4 bg-gradient-to-br from-[#0A5FFF] to-[#00C853]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            ¿Listo para empezar a ahorrar en tu luz?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Sube tu factura ahora y te respondemos en menos de 24 horas
          </p>
          <Link
            to="/subir-factura"
            className="inline-flex items-center justify-center gap-3 bg-[#FF8F00] hover:bg-[#E68000] text-white font-bold px-10 py-6 rounded-full text-xl transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            🔥 Enviar mi factura ahora
          </Link>
          <p className="text-white/80 text-sm mt-6">
            Sin compromiso • Revisión gratuita • Respuesta garantizada
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}